var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column align-center"},[_c('img',{attrs:{"src":require("../../assets/logo.png"),"height":_vm.size}}),(_vm.showName)?_c('small',[_vm._v(" "+_vm._s(_vm.$t("application.appname"))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }